import { FC, useEffect, KeyboardEvent } from 'react';
import api, { signInNew } from '../../API';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { resLogged, setLoggedIn, setToken, setUser } from '../../redux/slices/userSlice';
import './Main.scss';
import { AuthService } from '../../services/auth/auth.service';
import { UserService } from '../../services/user.service';
import { useNavigate } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';
import SInput from '../../components/UI/Input/SInput';
import SButton from '../../components/UI/Button/SButton';
import BrandLogo from '../../components/UI/BrandLogo/BrandLogo';
import ContactsInfo from '../../components/UI/ContactsInfo/ContactsInfo';

interface MainProps {
  title?: string;
}

const Main: FC<MainProps> = ({
  title = "Главная"
}) => {

  const loggedIn = useAppSelector((state) => state.usersR.loggedIn)
  const dispatch = useAppDispatch();

  let navigate = useNavigate();

  useEffect(() => {
    auth()
  }, [])

  const auth = async () => {
    try {
      const profile = await UserService.getProfile()
    } catch (e) {
      localStorage.removeItem('token')
      dispatch(setLoggedIn(false));
      dispatch(resLogged());
      navigate('/');
    }
  }

  const authorization = (data: signInNew) => {
    const { username, password } = data;
    api.signin({
      username, password
    }).then((res: any) => {
      if (res.auth_token) {
        dispatch(setToken(res.auth_token))
        api.getUserData()
          .then((res: any) => {
            dispatch(setUser(res))
            dispatch(setLoggedIn(true));
          })
          .catch(err => {
            dispatch(setLoggedIn(false));
          })
      } else {
        dispatch(setLoggedIn(false));
      }
    })
      .catch(err => {
        const errors = Object.values(err)
        if (errors) {
          alert(errors.join(', '))
        }
        dispatch(setLoggedIn(false));
      })
  }

  const onSignOut = () => {
    dispatch(setLoggedIn(false));
    dispatch(resLogged());
  }


  const titleM = title;
  const Auth = async () => {
    const log = (document.querySelector('#login') as HTMLInputElement).value
    const pas = (document.querySelector('#password') as HTMLInputElement).value
    const data = {
      username: log,
      password: pas
    }

    const dataSend = {
      login: log,
      password: pas
    }


    toast('Ожидайте');
    try {
      const res = await AuthService.main('login', dataSend)
      toast('Получение профиля');
      if (res) {
        const resUser = {
          email: res.user.email,
          id: res.user.id,
          username: res.user.login,
          fio: res.user.name,
          nickname: res.user.name,
          role: res.user.roles[0],
        }
        dispatch(setLoggedIn(true));
        dispatch(setUser(resUser))
        toast('Успешно!');
      }
    } catch (e: any) {
      toast('Ошибка!');
      if (e) {
        console.log(e.response.data.message)
        alert(`${e.response.data.message} \nПроверьте логин и пароль`)
      }
      dispatch(setLoggedIn(false));
      dispatch(setUser({}))
    }
  }

  const AuthClose = () => {
    onSignOut()
  }

  const handleLoginKeyUp = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      (document.querySelector('#password') as HTMLInputElement)?.focus();
    }
  };

  const handlePasswordKeyUp = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      Auth();
    }
  };

  return (
    <div className="main">
      <div className='main__content'>
        <div className='main__content-wrapper'>
          <BrandLogo />
          <div className='main__content-box'>
            {!loggedIn ?
              <div className='auth-form'>
                <SInput id='login' label='Логин' onKeyUp={handleLoginKeyUp} />
                <SInput id='password' type='password' label='Пароль' onKeyUp={handlePasswordKeyUp} />
                <SButton onClick={Auth}>Войти</SButton>
              </div>
              :
              <SButton onClick={AuthClose}>Выйти</SButton>
            }
            <ContactsInfo />
          </div>
        </div>
      </div>
      <Toaster
        position="top-center"
      />
    </div>
  );
}

export default Main;
